import { styled } from '@mui/material';

export const UlStyled = styled('ul')(({ theme }) => ({
  'li::marker': {
    display: 'block',
    fontSize: theme.fonts.utility.size(9),
  },
}));
